import { ApiProxy } from './APIProxy'
import { FeatureFlagLight } from '../model/config'

export class FeaturesService {
  constructor(private apiProxy: ApiProxy) {}

  getFeatures: () => Promise<FeatureFlagLight> = () =>
    this.apiProxy.get<FeatureFlagLight>('/config')
}
